import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Channel } from '@app/_components/channel';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class ChannelService {

	statuses: any = [
		{ value: '1', name: 'Active' },
		{ value: '0', name: 'Inactive' }

	];

	channelSourceIds: any = [
		{ value: 1, name: 'VRBO' },
		{ value: 2, name: 'FlipKey' },
		{ value: 3, name: 'Homeaway' },
		{ value: 4, name: 'CRAIGSLIST' },
		{ value: 5, name: 'REFERRAL' },
		{ value: 6, name: 'GUEST' },
		{ value: 7, name: 'GOOGLE' },
		{ value: 8, name: 'UNKNOWN' },
		{ value: 9, name: 'OWNER' },
		{ value: 10, name: 'FAMILY' },
		{ value: 11, name: 'WEBSITE' },
		{ value: 12, name: 'EXPEDIA' },
		{ value: 13, name: 'BOOKINGCOM' },
		{ value: 14, name: 'AIRBNB' },
		{ value: 15, name: 'MARRIOTT' },
		{ value: 16, name: 'TRIPADVISOR' },
		{ value: 17, name: 'GOLFHOM' },
		{ value: 18, name: 'REALTOR' },
		{ value: 19, name: 'WHIMSTAY' }, // added by JPM 10-7-2024
		{ value: 20, name: 'HOPPER' }, // added by JPM 10-7-2024
		{ value: 21, name: 'PLUMBGUIDE' }, // added by JPM 10-7-2024

	];

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService,
		) { }

	urlEndpoint = 'channels';

	add(channel: Channel): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(channel));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, channel);
	}

	update(channel: Channel): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, channel);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	/*getCMPullPropertiesStatusRS(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/dictionary/CM_Pull_PropertiesStatus_RQ`).pipe(retry({ count: 2, delay: 1500 }));
	}*/


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
